<template>
  <div>
    <el-form label-width="10px">
      <el-form-item>
        <span style="margin-right: 20px">统计时间 :</span>
        <el-radio v-model="queryForm.evaluateTime" @change="timeChange" v-for="item in options.evaluateTimeOpt"
          :key="item.value" :label="item.value">{{ item.label }}</el-radio>
        <div class="my_select_time">
          <el-date-picker prefix-icon="no_icon" v-model="postForm.startDate" type="date" :placeholder="'选择日期时间'"
            size="small" :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" style="width: 120px; font-size: 12px" class="time1"
            :clearable="false"></el-date-picker>
          <div class="time_to_text" :class="{
            to_text_disabled: queryForm.evaluateTime != 0 || !queryForm.evaluateTime,
          }">
            至
          </div>
          <el-date-picker prefix-icon="no_icon" v-model="postForm.endDate" type="date" :placeholder="'选择日期时间'"
            size="small" :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" style="width: 145px; font-size: 12px" class="time2"
            :clearable="true"></el-date-picker>
          <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime()"></i>
          <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
        </div>
        <el-button class="b1" style="margin-left: 20px" @click="querySeach()"><span style="marginleft: 4px">
            查询</span></el-button>
        <el-button class="b2" style="margin-left: 20px" @click="queryOne()"><span
            style="marginleft: 4px">重置</span></el-button>
      </el-form-item>
    </el-form>
    <div class="background">
      <span class="title"></span>&nbsp;
      <span class="tips">数据总览</span>
    </div>
    <div v-loading="loading">
      <div class="overview1" style="float: left" v-for="(item, index) in dataSummary" :key="index + item.value">
        <div>
          <span class="fontClass">{{ item.name }}</span>
          <el-popover v-if="item.tips" placement="top-start" width="200" offset="100" trigger="hover"
            :content="item.tipsName">
            <span style="float: right; margin-top: -10px" slot="reference">
              <p class="question_icon">?</p>
            </span>
          </el-popover>
        </div>
        <div class="num">{{ tableTotal[item.value] }}</div>
      </div>
    </div>
    <div style="clear: left" ref="payRemindChart" class="chart" v-loading="loading"></div>
    <el-table :data="activityTable" :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }"
      :cell-style="{ 'text-align': 'left' }" style="width: 100%; margin: 40px auto">
      <el-table-column prop="statsDate" label="参与时间"> </el-table-column>
      <el-table-column label="活动参与统计">
        <template slot-scope="scope">
          <span>招募会员人数:{{ scope.row.joinMemberCount }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span>领取优惠券人数:{{ scope.row.takeCouponCount }} </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeChange" background
      @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
      layout="total, sizes, prev, pager, next, jumper" :total="totalNum"
      :current-page="formList.current"></el-pagination>
  </div>
</template>

<script>
import { getLiveSum, getLiveChart, getLiveList } from "@/api/liveCard/liveCard";
import echarts from "echarts";
export default {
  components: {},
  data() {
    return {
      activityTable: [],
      loading: false,
      queryForm: {
        evaluateTime: "7",
      },
      postForm: {
        startDate: "",
        endDate: "",
      },
      tableTotal: {
        pv: 0, // 会员中心首页PV
        uv: 0, // 会员中心首页uv
        joinMemberCount: 0, // 招募人数
        takeCouponCount: 0, // 领券人数
      },
      dataSummary: [
        {
          value: "pv", // 对应tableTotal的字段
          name: "活动PV",
          tips: true, // 提示的显示隐藏
          tipsName: "活动页面访问次数，刷新一次或点击一次都算一次PV流量。", // 提示语
          color: "#EFB37E", // 折现颜色
        },
        {
          value: "uv",
          name: "活动UV",
          tips: true,
          tipsName: "活动页面访问人数，指访问某个站点或点击某个网页的不同IP地址的人数。",
          color: "#B2A8DA",
        },
        {
          value: "joinMemberCount",
          name: "招募会员人数",
          tips: true,
          tipsName: "招募会员人数",
          color: "#F2D0B5",
        },
        {
          value: "takeCouponCount",
          name: "领取优惠券人数",
          tips: true,
          tipsName: "领取优惠券人数",
          color: "#F4ACB9",
        },
      ],
      //查询条件
      options: {
        evaluateTimeOpt: [
          {
            value: "7",
            label: "近七天",
          },
          {
            value: "15",
            label: "近15天",
          },
          {
            value: "30",
            label: "近30天",
          },
          {
            value: "0",
            label: "自定义",
          },
        ],
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.postForm.startDate) {
            return time.getTime() < new Date(this.postForm.startDate).getTime();
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.postForm.endDate) {
            return time.getTime() > new Date(this.postForm.endDate).getTime();
          } else {
          }
        },
      },
      chartEffectDetail: [],
      //折线图数据
      myCharts: null,
      formList: {
        size: 10,
        current: 1
      },
      totalNum: 0
    };
  },

  async mounted() {
    await this.timeChange()
    await this.getLiveSum()
    await this.getLiveChart()
    await this.getLiveList()
    await this.initChart()
  },

  methods: {
    //分页事件
    handleSizeChange(val) {
      this.formList.size = val;
      this.getLiveList();
    },

    handleCurrentChange(val) {
      this.formList.current = val;
      this.getLiveList();
    },

    // 列表数据
    async getLiveList() {
      const obj = {
        ...this.formList,
        startTime: String(this.postForm.startDate),
        endTime: String(this.postForm.endDate),
      }
      const res = await getLiveList(obj)
      this.activityTable = res.data.records
      this.totalNum = res.data.total
    },

    // 汇总数据
    async getLiveSum() {
      this.loading = true
      const res = await getLiveSum({ startTime: String(this.postForm.startDate), endTime: String(this.postForm.endDate) })
      this.loading = false

      for (let key in res.data) {
        this.tableTotal[key] = res.data[key]
      }
    },

    // 折线图数据
    async getLiveChart() {
      const res = await getLiveChart({ startTime: this.postForm.startDate, endTime: this.postForm.endDate })
      this.chartEffectDetail = res.data

      this.$nextTick(() => {
        this.initChart();
        window.addEventListener("resize", () => {
          this.myCharts.resize();
        });
      });
    },

    //折线图
    initChart() {
      this.myCharts = echarts.init(this.$refs.payRemindChart);
      this.setOptions();
    },
    //折线图事件
    setOptions() {
      const seriesList = this.dataSummary.map((item) => {
        return {
          name: item.name,
          type: "line",
          smooth: true,
          color: item.color,
          data: this.chartEffectDetail.map((i) => i[item.value]),
        };
      });
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          // data: ["活动PV", "活动UV", "参与人数", "参与次数", "人均参与次数"],
          data: this.dataSummary.map((item) => item.name),
          bottom: -5,
          // left: "center",
          x: "center",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "11%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartEffectDetail.map((item) => item.statsDate),
        },
        yAxis: {
          type: "value",
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: seriesList,
      };

      this.myCharts.setOption(option);
    },

    // 查询按钮
    querySeach() {
      this.formList.current = 1;
      this.formList.size = 10;
      if(this.postForm.endDate == "" || this.postForm.startDate == "") {
        this.$message.error("请输入统计时间");
        return
      }
      if(this.queryForm.evaluateTime == 0) {
        this.postForm.startDate = this.postForm.startDate + " " + "00:00:00"
        this.postForm.endDate = this.postForm.endDate + " " + "23:59:59"
      }
      this.postForm.startDate = this.postForm.startDate.slice(0, 10) + " " + "00:00:00"
      this.postForm.endDate = this.postForm.endDate.slice(0, 10) + " " +  "23:59:59"
      this.getLiveSum()
      this.getLiveChart()
      this.getLiveList()
    },

    //重置
    queryOne() {
      this.formList.current = 1;
      this.formList.size = 10;
      this.queryForm.evaluateTime = "7";
      this.timeChange(7);
      this.getLiveSum()
      this.getLiveChart()
      this.getLiveList()
    },

    //时间限制
    clearTimeSendTime() {
      this.postForm.startDate = "";
      this.postForm.endDate = "";
    },

    timeChange(type) {
      let self = this;
      let hh = new Date().getHours() < 10 ? "0" + new Date().getHours() : new Date().getHours();
      let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();
      let tt = "00:00:00";
      let tt1 = "23:59:59"
      const date = [self.getDay(-7, "-"), self.getDay(0, "-")];
      this.mytime = date;
      if (type == null) {
        this.postForm.startDate = `${this.mytime[0]} ${tt}`;
        this.postForm.endDate = `${this.mytime[1]} ${tt1}`;
      } else if (type == 7) {
        this.postForm.startDate = `${this.mytime[0]} ${tt}`;
        this.postForm.endDate = `${this.mytime[1]} ${tt1}`;
        this.getLiveSum()
        this.getLiveChart()
        this.getLiveList()
      } else if (type == 15) {
        this.mytime[0] = self.getDay(-15, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startDate = `${this.mytime[0]} ${tt}`;
        this.postForm.endDate = `${this.mytime[1]} ${tt1}`;
        this.getLiveSum()
        this.getLiveChart()
        this.getLiveList()
      } else if (type == 30) {
        this.mytime[0] = self.getDay(-30, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startDate = `${this.mytime[0]} ${tt}`;
        this.postForm.endDate = `${this.mytime[1]} ${tt1}`;
        this.getLiveSum()
        this.getLiveChart()
        this.getLiveList()
      } else {
        this.postForm.startDate = "";
        this.postForm.endDate = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.b1 {
  width: 98px;
  height: 32px;
  color: #fff;
  border: 1px solid #2670fb;
  background-color: #2670fb;

  &:hover {
    opacity: 0.8;
  }
}

.b2 {
  width: 98px;
  height: 32px;
  color: #666666;
  border: 1px solid #dddddd;
  background-color: #fff;

  &:hover {
    color: #2670fb;
    border: 1px solid #2670fb;
    background: rgba(38, 112, 251, 0.1);
  }
}

.background {
  height: 32px;
  background: rgba(250, 250, 250, 1);
  opacity: 1;
  line-height: 32px;
  padding-left: 12px;

  .title {
    display: inline-block;
    width: 2px;
    height: 14px;
    background: #2670fb;
    opacity: 1;
    border-radius: 3px;
    vertical-align: middle;
  }

  .tips {
    width: 56px;
    height: 20px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    opacity: 1;
    vertical-align: middle;
  }
}

.overview1 {
  padding: 26px 30px 22px 30px;
  width: 25%;
  height: 100px;
  border-right: 1px solid #f3f3f3;
  opacity: 1;
  margin: 20px 0px;

  .fontClass {
    width: 102px;
    height: 20px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: rgba(102, 102, 102, 1);
    opacity: 1;
  }

  .question_icon {
    width: 14px;
    height: 14px;
    color: #cccccc;
    display: inline-block;
    line-height: 12px;
    text-align: center;
    border-radius: 14px;
    border: 1px solid #cccccc;
    font-size: 12px;
    font-weight: normal;
  }

  .num {
    width: 65px;
    height: 29px;
    font-size: 24px;
    font-family: DIN;
    font-weight: bold;
    line-height: 29px;
    color: #2670fb;
    opacity: 1;
    margin-top: 14px;
    margin-bottom: 30px;
  }
}

.chart {
  height: 380px;
  min-width: 1100px;
}
</style>
